import { OwnedObject, parseFloatOr } from 'gear';
import { Xml } from '../util';
import { Point, Matrix } from '../geometry';


function parsePos( node ) {
  return new Point( parseFloatOr(node.getAttribute('X'), 0.0 ),
                    parseFloatOr(node.getAttribute('Y'), 0.0 ) ) ;
}

function setPos(node,pos) {
  Xml.setFloatAttr(node,'X',pos.x);
  Xml.setFloatAttr(node,'Y',pos.y);
}

function parseRelPos( node ) {
    return new Point( parseFloatOr(node.getAttribute('RelX'), 0.5 ),
                      parseFloatOr(node.getAttribute('RelY'), 0.5 ) ) ;
}

function setRelPos(node,relPos) {
  Xml.setFloatAttr(node,'RelX',relPos.x);
  Xml.setFloatAttr(node,'RelY',relPos.y);
}

// [TODO] Eliminate Pin, we do not need it anymore. Bounds based pinning is
//        no longer supported

// Pin
//--------------------------------------------------------------------------------------

export const Pin = function(pos,useAnchor,relPos) {
  if( pos instanceof Pin ) {
    return new Pin(pos.getPos(),pos.use,pos.getRelPos());
  }
  if( pos === undefined ) { this.x = 0.0   ; this.y = 0.0   ; }
  else                    { this.x = pos.x ; this.y = pos.y ; }
  if( useAnchor === undefined ) { this.use = "Anchor"; }
  else                          { this.use = useAnchor ? "Anchor" : "Bounds" ; }
  if( relPos === undefined ) { this.relX = 0.5 ; this.relY = 0.5 ; }
  else                       { this.relX = relPos.x ; this.relY = relPos.y ; }
  /* We keep the same layout to provide backward compatibility, it will be nice to
     be able to change this with something like:
  this.pos       = pos ;
  this.useAnchor = useAnchor ;
  this.relPos    = relPos ;
  */
};
Pin.fromXml = function(fNode) {
  const node = Xml.child(fNode,'Pin');
  if( ! node ) { return new Pin(); }
  const pos = parsePos(node) ;
  const useNode = node.getAttribute('Use') ;
  const useAnchor = useNode ? useNode.toLowerCase() === 'anchor' : false ;
  const relPos = parseRelPos(node) ;
  return new Pin(pos,useAnchor,relPos) ;
};
Pin.prototype = {
  buildXml ( fNode) { Xml.addObject(fNode,this,'Pin'); },
  setupXml( node ) {
    if(this.anchorBased()) {
      node.setAttribute('Use','Anchor');
    }
    else {
      setRelPos( node, this.getRelPos() );
    }
    setPos( node, this.getPos() );
  },
  getPos() {
    return new Point(this.x,this.y);
  },
  getRelPos() {
    return new Point(this.relX,this.relY);
  },
  anchorBased() {
    return this.use.toLowerCase() === 'anchor';
  },
  cloneElsewhere( newPoint ) {
    return new Pin(newPoint,this.anchorBased(),this.getRelPos());
  },
  clone() {
    return new Pin(this.getPos(),this.anchorBased(),this.getRelPos());
  },
  isEqual( other ) {
    return this.use === other.use && this.getPos().isEqual(other.getPos()) &&
           ( this.anchorBased() || this.getRelPos().isEqual(other.getRelPos()) );
  }
};

// AnchorGenerator
//--------------------------------------------------------------------------------------

export const AnchorGenerator = OwnedObject.extend({ typeName: 'Anchor',

  Properties : {
    pos      : { type : 'Point'  , def: new Point(0.5,0.5) }, // [TODO] invalidation
    absolute : { type : 'boolean', def: false }
  },

  buildXml ( fNode) {
    Xml.addObject(fNode,this,'Anchor');
  },
  setupXml( node ) {
    if( this._absolute ) {
      setPos( node, this._pos );
    }
    else {
      setRelPos( node, this._pos );
    }
  },
  of( frame) {
    return this._absolute ? this._pos.clone() : frame.interpolate(this._pos);
  }
});

AnchorGenerator.fromXml = function( fNode ) {
  const node = Xml.child(fNode,'Anchor');
  if( !node ) {
    return new AnchorGenerator();
  }
  return AnchorGenerator.parseXml(node) ;
};
AnchorGenerator.parseXml = function( node ) {
  const absolute = !!node.getAttribute('X');
  return new AnchorGenerator({
    absolute,
    pos: absolute ? parsePos(node) : parseRelPos(node)
  });
};

export const AbsoluteAnchor = function( pos ) {
  return new AnchorGenerator({ pos, absolute: true });
};

export const RelativeAnchor = function( pos ) {
  return new AnchorGenerator({ pos, absolute: false });
};



// FigureTransform
//--------------------------------------------------------------------------------------
// This class is only intended to help in the decoding and enconding, because the
// transform of the figure is tied with the postConstraint

export const FigureTransform = {

  buildXml( matrix,node ) {
    const el = Xml.appendElement(node,'Transform');
    matrix.setMatrix22Attr(el,'Matrix22');
    return el ;
  },
  fromXml( fNode ) {
    const t = Xml.getObject(fNode,this,'Transform') ;
    return t || { matrix: new Matrix() } ;
  },
  parseXml( node ) {
    const p = {};
    p.matrix = Matrix.getMatrix22Attr(node, 'Matrix22');
    const c = Xml.getFloatArrayAttr(node, 'Constrain', null);
    if( c !== null ) {
      p.postConstraint = { x: c[0], y: c[1] };
    }
    return p;
  }
};

// Extends Xml.Parser

Xml.Parser['Anchor'] = Xml.makeObjectParser(AnchorGenerator);



/** WEBPACK FOOTER **
 ** ./src/cdl/figure/anchor.js
 **/